export const DATE_FORMATS = {
  LOCALIZED_DATE: "L",
} as const
